import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { List } from 'immutable';

import {GenericModals} from "../../constants/AppConstants";
import PassengersForm from '../../records/search/PassengersForm';
import TrackingActions from "../../actions/TrackingActions";

import BaseModal from '../general/BaseModal';
import Railcards from './Railcards';

import PassengersSelector from './PassengersSelector';
import PureRenderComponent from '../PureRenderComponent';


class PassengersModal extends PureRenderComponent {

    static propTypes = {
        show: PropTypes.bool.isRequired,
        railcards: PropTypes.instanceOf(List),
        adults: PropTypes.number.isRequired,
        children: PropTypes.number.isRequired,
        onCancel: PropTypes.func,
        onSelect: PropTypes.func,
        Form: PropTypes.func,
        hideRailcards: PropTypes.bool,
        hideFareInfo: PropTypes.bool,
    };

    static defaultProps = {
        railcards: null,
        onCancel: _.noop,
        onSelect: _.noop,
        Form: PassengersForm,
        hideRailcards: false,
        hideFareInfo: false,
    };

    state = {
        railcards: this.props.railcards,
        adults: this.props.adults,
        children: this.props.children
    };

    _handleChangeFor = (key) => (value) => {
        this.setState({
            [ key ]: value
        });
    };

    _onSave = () => {
        const railcards = this.state.railcards ? this.state.railcards.filter((railcard) => railcard.code) : null;

        if (!this._hasErrors()) {
            this.props.onSelect(this.state.adults, this.state.children, railcards);
        }
    };

    _hasErrors () {
        const form = new this.props.Form(this.state);

        return !form.isComplete();
    }

    _isDirty () {
        return this.props.children !== this.state.children ||
               this.props.adults !== this.state.adults ||
               this.props.railcards !== this.state.railcards;
    }

    render () {
        const { adults, children, railcards } = this.state;
        const { hideRailcards } = this.props;

        const modalProps = {
            show: this.props.show,
            onClose: this.props.onCancel,
            onContinue: this._onSave,
            closeText: 'button.text.cancel',
            continueText: 'button.text.select',
            disableBlur: this._isDirty(),
            disableContinue: this._hasErrors(),
            titleText: 'booking.passengers.modal.title' + (railcards ? '.withRailcards' : ''),
            className: 'modal--sm',
            onOpen: () => {
                TrackingActions.genericModalOpen(GenericModals.PASSENGERS_RAILCARDS);
            }
        };

        return (
            <BaseModal { ...modalProps }>
                <section className="modal-body__passengers">

                    <PassengersSelector
                        adults={ adults }
                        children={ children }
                        onAdultsChange={ this._handleChangeFor('adults') }
                        onChildrenChange={ this._handleChangeFor('children') }
                        Form={ this.props.Form }
                        hideInfo={ this.props.hideFareInfo }
                    />

                    { railcards && !hideRailcards &&
                        <Railcards
                            adults={ adults }
                            children={ children }
                            railcards={ railcards }
                            onRailcardsChange={ this._handleChangeFor('railcards') }
                            Form={ this.props.Form }
                        />
                    }
                </section>
            </BaseModal>
        );
    }

}


export default PassengersModal;



// WEBPACK FOOTER //
// ./src/components/search/PassengersModal.js